<a class="visually-hidden-focusable skip-link" href="#main-content">Zum Inhalt springen</a>

<t2d-app-shell
  appTitle=""
  logoSrc="assets/logos/planaudit/logo/PlanAudit_Logo_Negativ_Bold.svg"
  [navItems]="filteredNavItems()"
  [user]="appUser()"
  [userMenuItems]="userMenuItems()"
  (logoutClick)="onLogout()"
>
  @if (zeigeUmgebungsBanner) {
    <app-environment-banner sidebarExtra variant="sidebar" />
  }
  @if (sidebarMandantLogoUrl(); as url) {
    <div sidebarExtra class="planaudit-sidebar-mandant-logo">
      <img [src]="url" [alt]="sidebarMandantName() + ' Logo'" />
    </div>
  }
  <app-update-available-banner />
  <app-maintenance-banner />
  <app-two-factor-required-banner />
  <app-breadcrumb />
  <router-outlet />
</t2d-app-shell>

<t2d-toast-container />
<t2d-confirm-dialog-host />
<t2d-delete-dialog-host />
<t2d-entity-tree-picker-host />
<t2d-dms-document-delete-dialog-host />
<app-two-factor-required-modal />
